import React from "react"
import { removeImageDescription } from "../utilities"
import DfbImage from "../ui-kit/dfb_image"
import CLightbox from "../elements/c_lightbox"
import CMediaVideo from "../elements/c_media_video"
import { Transformation } from "cloudinary-react"
import Section from "./section"

const MTextHighlightImage = (props) => {
  let image_width = ""
  let image_height = ""
  let lightbox_attributes = {}
  let modal_id = ""
  let show_lightbox = props.show_lightbox ? props.show_lightbox : true
  if (show_lightbox) {
    modal_id = `modal-uid-${props.data.uid}`
    lightbox_attributes = { "data-toggle": "modal", "data-target": modal_id }
  }

  if (props.data.aspect_ratio && props.data.aspect_ratio === "4:3") {
    image_width = "444"
    image_height = "333"
  } else if (props.data.aspect_ratio && props.data.aspect_ratio === "3:4") {
    image_width = "444"
    image_height = "592"
  } else if (props.data.aspect_ratio && props.data.aspect_ratio === "2:3") {
    image_width = "444"
    image_height = "666"
  } else {
    image_width = "444"
    image_height = "250"
  }
  return (
    <Section
      baseClass="m-TextHighlight m-TextHighlight--image"
      className={
        props.data.reverse === "reverse"
          ? "m-TextHighlight--reverse"
          : undefined
      }
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-TextHighlight-wrapper">
        <div className="m-TextHighlight-container">
          <blockquote className="m-TextHighlight-highlight">
            <strong className="m-TextHighlight-highlightBig">
              {props.data.highlight_number}
            </strong>
            <div className="m-TextHighlight-highlightSmall">
              {props.data.plaintext}
            </div>
          </blockquote>
          {props.data.video_embed_id && (
            <div className="m-TextHighlight-media">
              <CMediaVideo video_embed_id={props.data.video_embed_id} />
            </div>
          )}
          {props.data.image && props.data.image.src && (
            <div className="m-TextHighlight-image" {...lightbox_attributes}>
              <DfbImage
                image={props.data.image}
                aspect_ratio={props.data.aspect_ratio}
              >
                <Transformation
                  crop="fill"
                  gravity="faces:center"
                  width={image_width}
                  height={image_height}
                  quality="auto"
                  fetchFormat="auto"
                />
              </DfbImage>
            </div>
          )}
        </div>
      </div>
      {show_lightbox && (
        <CLightbox
          id={modal_id}
          image={removeImageDescription(props.data.image)}
          width="1600"
          height="900"
        ></CLightbox>
      )}
    </Section>
  )
}

export default MTextHighlightImage
